/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

document.addEventListener( 'DOMContentLoaded', function() {
    
    const block_containers = document.querySelectorAll( '.realisation-item' );

    for ( let i = 0; i < block_containers.length; i++ ) {

        // On initialise les galeries de matériaux
        if ( 'undefined' !== typeof lightGallery ) {
            const galleries = block_containers[i].querySelectorAll( '.realisation-gallery' );
            for ( let j = 0; j < galleries.length; j++ ) {
                lightGallery( galleries[j], {
                    thumbnail: true,
                    download: false,
                    actualSize: false,
                } );
            }
        }

        // On va chercher le bouton de chargement pour y appliquer les événements de clic
        const load_more_button = block_containers[i].querySelector( '.realisation-load-more' );
        if ( load_more_button ) {
            load_more_button.addEventListener( 'click', function(e) {
                e.preventDefault();
                if ( block_containers[i].classList.contains( 'showall') ) {
                    block_containers[i].classList.remove( 'showall' );
                } else {
                    block_containers[i].classList.add( 'showall' );
                }
            });
        }
            
    }

});